import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Phone, CheckCircle2 } from "lucide-react";

export default function PageHero({ eyebrow, title, subtitle, img, imgPosition }) {
  return (
    <section className="relative min-h-[60vh] md:min-h-[70vh] flex items-end overflow-hidden grain border-b border-[#DCB457]/15">
      <div className="absolute inset-0">
        <img
          src={img}
          alt={eyebrow}
          fetchPriority="high"
          decoding="async"
          className="w-full h-full object-cover"
          style={imgPosition ? { objectPosition: imgPosition } : undefined}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/95 via-black/70 to-black/40" />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-black/40" />
      </div>
      <div className="spotlight bg-[#DCB457]/25 w-[500px] h-[500px] -top-32 -left-20" />
      <div className="relative z-10 max-w-[1400px] mx-auto w-full px-6 md:px-10 lg:px-14 pb-20 pt-32">
        <div className="flex items-center gap-3 mb-5">
          <span className="gold-line" />
          <span className="eyebrow">{eyebrow}</span>
        </div>
        <h1 className="font-serif-luxe text-[2.75rem] sm:text-[4rem] md:text-[5.5rem] lg:text-[6.5rem] leading-[0.95] tracking-tight max-w-4xl">
          {title}
        </h1>
        {subtitle && (
          <p className="mt-6 text-white/70 text-base md:text-lg max-w-2xl leading-relaxed">{subtitle}</p>
        )}
        <div className="mt-10 flex flex-wrap gap-3">
          <Link to="/contact" data-testid="pagehero-devis-btn" className="btn-gold">
            Demander un devis <ArrowRight size={16} strokeWidth={1.4} />
          </Link>
          <a href="tel:0769224956" data-testid="pagehero-call-btn" className="btn-ghost-gold">
            <Phone size={15} strokeWidth={1.4} /> Appeler maintenant
          </a>
        </div>
      </div>
    </section>
  );
}

export function FeatureList({ items }) {
  return (
    <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-4">
      {items.map((it) => (
        <li key={it} className="flex items-start gap-3 text-white/80 text-base">
          <CheckCircle2 size={18} strokeWidth={1.2} className="text-[#DCB457] mt-0.5 shrink-0" />
          <span>{it}</span>
        </li>
      ))}
    </ul>
  );
}
